import { render } from "./AddPlantSelected.vue?vue&type=template&id=710d7502&scoped=true"
import script from "./AddPlantSelected.vue?vue&type=script&lang=js"
export * from "./AddPlantSelected.vue?vue&type=script&lang=js"

import "./AddPlantSelected.vue?vue&type=style&index=0&id=710d7502&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710d7502"]])

export default __exports__